document.addEventListener('DOMContentLoaded', function () {
  const flipcards = document.querySelectorAll('.flip-card');
  const listContainer = document.querySelector('section#customer_case .row#listCase');
  if (flipcards.length === 0 || !listContainer) return;

  const listLimit = 11;
  const modalBody = document.querySelector('#cas-client-details .modal-body');
  const flipCardList = {};

  try{
    flipcards.forEach(fc => {
      const list = Array.from(fc.querySelectorAll('li'));
      if (list.length <= listLimit) return;

      const uniqId = crypto.randomUUID();
      fc.setAttribute('data-id', uniqId);

      // On stocke les originaux avant de toucher au DOM
      flipCardList[uniqId] = list.map(li => li.cloneNode(true));

      const ul = fc.querySelector('ul');
      ul.innerHTML = '';
      list.slice(0, listLimit).forEach(li => ul.appendChild(li.cloneNode(true)));

      fc.querySelector('.flip-card-back').insertAdjacentHTML('beforeend', `
        <div class="d-flex justify-content-end align-items-end flex-grow-1">
          <button 
            type="button" 
            class="flip-card-from-back text-white d-flex align-items-center fw-bold showMore"
            data-bs-toggle="modal"
            data-bs-target="#cas-client-details"
          >
            <span>Voir plus</span>
            <img src="assets/webp/arrow-orange.webp" alt="" height="36" width="36" class="ms-2" />
          </button>
        </div>
      `);
    });

    document.querySelectorAll('button.showMore').forEach(sm => {
      sm.addEventListener('click', () => {
        const id = sm.closest('.flip-card').getAttribute('data-id');
        const flipCard = document.querySelector(`.flip-card[data-id="${id}"]`);
        const backContent = flipCard.querySelector('.flip-card-back').cloneNode(true);

        backContent.querySelector('.showMore')?.closest('div')?.remove();

        const modalHeader = document.querySelector('#cas-client-details .modal-header');
        const headerContent = backContent.querySelector('div');

        // On reconstruit le ul complet depuis flipCardList
        const ul = document.createElement('ul');
        ul.className = backContent.querySelector('ul').className;
        flipCardList[id].forEach(li => ul.appendChild(li.cloneNode(true)));

        modalHeader.querySelector('div')?.remove();
        modalBody.innerHTML = '';

        modalHeader.insertAdjacentElement('afterbegin', headerContent);
        modalBody.appendChild(ul);
      });
    });

    flipcards.forEach(card => {
      card.querySelector('.flip-card-front').addEventListener('click', () => {
        card.classList.toggle('flipped');
      });
    });
  } finally {
    listContainer.classList.add('ready');
  } 
});